// extracted by mini-css-extract-plugin
module.exports = {"total":"Rewards_total__1_a3c","number":"Rewards_number__2BpbD","small":"Rewards_small__1CT3O"};